/* Behavioral evidence only. All delivery uses PTAnalytics and its privacy/ignore controls. */
(function () {
  'use strict';
  if (window.PTV7JourneyObserver) return;
  window.PTV7JourneyObserver = true;
  var emitted = Object.create(null), pendingRoute = null, activeRoute = null;
  var questions = null, root = null, observer = null, scheduled = false;
  var questionIntersection = false, questionTimer = 0;
  function track(type, detail) {
    try {
      var analytics = window.PTAnalytics;
      if (!window.PTConsent || !window.PTConsent.allowed('analytics')) return false;
      if (analytics && analytics.isIgnored && analytics.isIgnored()) return false;
      if (!analytics || typeof analytics.track !== 'function') return false;
      analytics.track(type, Object.assign({ measurement_schema: 'questions_v1' }, detail || {}));
      return true;
    } catch (_) { return false; } // Observation must never interrupt the purchase path.
  }
  function once(type, route) {
    var key = type + ':' + route;
    if (!emitted[key] && track(type, { entry_route: route })) emitted[key] = true;
  }
  function questionRoute() {
    return location.pathname === '/' ? 'home_questions' :
      /\/products\//.test(location.pathname) ? 'product_questions' : 'other_questions';
  }
  function directRoute() {
    return new URLSearchParams(location.search).get('ptq_resume') === '1' ? 'saved_draft' :
      /\/products\//.test(location.pathname) ? 'product_direct' : 'other_entry';
  }
  function visible(el) {
    if (!el || !el.isConnected || document.visibilityState === 'hidden' ||
        el.closest('[hidden],[inert],[aria-hidden="true"]')) return false;
    for (var n = el; n && n.nodeType === 1; n = n.parentElement) {
      var style = getComputedStyle(n);
      if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return false;
    }
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0 && r.bottom > 0 && r.right > 0 && r.top < innerHeight && r.left < innerWidth;
  }
  function questionsVisible() {
    if (!questionIntersection || !visible(questions)) return false;
    // Do not count a form covered by a consent/modal overlay as a seen entry.
    var r = questions.getBoundingClientRect();
    var x = (Math.max(0, r.left) + Math.min(innerWidth, r.right)) / 2;
    var y = (Math.max(0, r.top) + Math.min(innerHeight, r.bottom)) / 2;
    var hit = document.elementFromPoint(x, y);
    return !!(hit && questions.contains(hit));
  }
  function checkQuestions() {
    if (!questionsVisible()) { clearTimeout(questionTimer); questionTimer = 0; return; }
    if (questionTimer || emitted['pt_v7_questions_visible:' + questionRoute()]) return;
    questionTimer = setTimeout(function () {
      questionTimer = 0;
      if (questionsVisible()) once('pt_v7_questions_visible', questionRoute());
    }, 500);
  }
  function isOpen() {
    return root && root.getAttribute('data-ptq-focus-mode') === '1' && visible(root);
  }
  function scan() {
    scheduled = false;
    var next = document.querySelector('#pt-unified-entry .pt-entry-questions');
    if (next !== questions) {
      if (observer && questions) observer.unobserve(questions);
      clearTimeout(questionTimer); questionTimer = 0; questionIntersection = false; questions = next;
      if (observer && questions) observer.observe(questions);
    }
    root = document.getElementById('pt-quick-b2c');
    if (isOpen()) {
      if (!activeRoute) activeRoute = pendingRoute || directRoute();
      pendingRoute = null;
      once('pt_v7_quickmode_opened', activeRoute);
      if (root.contains(document.activeElement)) once('pt_v7_quickmode_focused', activeRoute);
    } else if (!root || root.getAttribute('data-ptq-focus-mode') !== '1') activeRoute = null;
    checkQuestions();
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true; requestAnimationFrame(scan);
  }
  window.addEventListener('pt:v7-name-preview-requested', function () {
    if (location.pathname !== '/') return;
    pendingRoute = 'home_name_preview';
    once('pt_v7_name_preview_requested', pendingRoute);
    schedule();
  });
  window.addEventListener('pt:v7-questions-completed', function () {
    pendingRoute = questionRoute();
    once('pt_v7_questions_completed', pendingRoute);
    schedule();
  });
  window.addEventListener('pt:v7-entry-failed', function () {
    once('pt_v7_questions_open_failed', pendingRoute || questionRoute());
    pendingRoute = null;
  });
  document.addEventListener('focusin', function (event) {
    scan();
    if (questions && questions.contains(event.target) && visible(event.target))
      once('pt_v7_questions_focused', questionRoute());
  }, true);
  document.addEventListener('input', function (event) {
    var el = event.target;
    if (event.isTrusted && el.id === 'pt-entry-name' &&
        el.getAttribute('data-ptq-text-slot') === 'recipient' && visible(el) && String(el.value || '').trim())
      once('pt_v7_questions_first_input', questionRoute());
  }, true);
  ['input', 'change', 'pointerdown', 'keydown'].forEach(function (type) {
    document.addEventListener(type, function (event) {
      if (!event.isTrusted) return;
      scan();
      if (isOpen() && root.contains(event.target)) once('pt_v7_quickmode_interacted', activeRoute);
    }, true);
  });
  function problem(code) {
    var key = 'error:' + code;
    if (!emitted[key] && track('pt_v7_ui_error', { error_code: code })) emitted[key] = true;
  }
  function ownQuickmodeFile(value) {
    try {
      var url = new URL(value, location.href);
      return (url.hostname === location.hostname || url.hostname === 'cdn.shopify.com') && /\/(?:pt-cert-|ptq-|pt-quick)[^/]*\.js(?:$|\?)/.test(url.pathname + url.search);
    } catch (_) { return false; }
  }
  window.addEventListener('error', function (event) {
    if (ownQuickmodeFile(event.filename || '')) problem('javascript_error');
  });
  if (typeof window.fetch === 'function') {
    var originalFetch = window.fetch;
    window.fetch = function () {
      // Capture route at request time, not when the asynchronous response arrives.
      var route = isOpen() ? activeRoute : null;
      var result = originalFetch.apply(this, arguments), url;
      try { url = new URL(typeof arguments[0] === 'string' || arguments[0] instanceof URL ? arguments[0] : arguments[0].url, location.href); }
      catch (_) { return result; }
      if (url.origin !== location.origin || !/^(?:\/[a-z]{2}(?:-[A-Z]{2})?)?\/cart\/add(?:\.js)?\/?$/.test(url.pathname)) return result;
      result.then(function (response) {
        if (response.ok) track('pt_v7_cart_confirmed', { http_status: response.status, entry_route: route || 'unknown' });
        else problem('cart_http_error');
      }, function () { problem('request_failed'); });
      return result;
    };
  }
  function ready() {
    once('pt_v7_site_version', 'page');
    if (typeof IntersectionObserver === 'function') observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.target === questions) questionIntersection = entry.isIntersecting && entry.intersectionRatio >= 0.5;
      });
      checkQuestions();
    }, { threshold: [0, 0.5] });
    // Dynamic entry mounting, focus-mode opening and consent overlay changes.
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true,
      attributes: true, attributeFilter: ['hidden', 'class', 'style', 'aria-hidden', 'inert', 'data-ptq-focus-mode'] });
    ['resize', 'scroll', 'pageshow', 'pt:entry-mounted'].forEach(function (type) { window.addEventListener(type, schedule, { passive: true }); });
    document.addEventListener('visibilitychange', schedule);
    document.addEventListener('pt:consent', function () {
      if (window.PTConsent && window.PTConsent.allowed('analytics')) {
        once('pt_v7_site_version', 'page'); schedule();
      } else { clearTimeout(questionTimer); questionTimer = 0; }
    });
    scan();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true });
  else ready();
})();
